import { render, staticRenderFns } from "./OrderSpinOffForm.vue?vue&type=template&id=1a07356b&"
import script from "./OrderSpinOffForm.vue?vue&type=script&lang=js&"
export * from "./OrderSpinOffForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderSpinOffForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCol,VRow,VTextField})
